/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContractOwnershipDto } from './subjectContractOwnershipDto.model';
import { SubjectContactEntity } from './subjectContactEntity.model';
import { SubstateFlagType } from './substateFlagType.model';
import { DepartmentContract } from './departmentContract.model';
import { VersionType } from './versionType.model';


export interface ContractListResponseDto { 
    appendixNumber?: number;
    appendixSourceId?: number;
    attachmentUploadedTypes?: string;
    contractNumber?: number;
    contractNumberOfficial?: string;
    contractSubjectOwnerships?: Array<SubjectContractOwnershipDto>;
    counterpartyNumber?: string;
    departmentContractList?: Array<DepartmentContract>;
    departmentCount?: number;
    durationMonths?: number;
    expirationDate?: string;
    groupId?: number;
    id?: number;
    indefinite?: boolean;
    owners?: Array<SubjectContactEntity>;
    parcelIds?: Array<number>;
    revisionId?: number;
    sentForSignature?: boolean;
    signatureDate?: string;
    signingProcess?: boolean;
    state?: string;
    stateOrder?: number;
    subcontract?: boolean;
    subjectOrderName?: string;
    substateFlag?: SubstateFlagType;
    successiveNextId?: number;
    successiveNumber?: number;
    successiveSourceId?: number;
    tenants?: Array<SubjectContactEntity>;
    validity?: string;
    validityExplanation?: string;
    versionType: VersionType;
}
export namespace ContractListResponseDto {
}


